/* Affichage des montants.

   Notation suisse « 160 340.- » : pas de symbole, donc valable aussi bien
   pour des francs que pour des euros. Séparateur de milliers en espace
   insécable, pour qu'un montant ne se coupe jamais en fin de ligne. */

const ESPACE = ' '

export function montant(valeur, { signe = false } = {}) {
  const n = Math.round(Number(valeur) || 0)
  const chiffres = Math.abs(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE)
  const prefixe = n < 0 ? '-' : signe && n > 0 ? '+' : ''
  return `${prefixe}${chiffres}.-`
}

/* Variante conservant les centimes, pour les prix unitaires où ils comptent. */
export function montantPrecis(valeur) {
  const n = Number(valeur) || 0
  const [entier, dec] = Math.abs(n).toFixed(2).split('.')
  const chiffres = entier.replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE)
  return `${n < 0 ? '-' : ''}${chiffres},${dec}`
}
